import React, { useEffect, useState } from "react";
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import { PageHemeaContainer, MainTitle, PartnerContent, Content, SideImage, MainLogo, Title, Text, Item, Icon, ItemsList, AdviseBlock, Advise, Photo, ConfirmButton } from './styled';
import { ProjectListWrapper } from '../page-project-list/styled';
import { useSelector } from 'react-redux';
import { projectSelector, selectedProjectSelector, userSelector, isHemeaSubmittedSelector } from '../../selectors';
import YellowStar from '../../static/yellow-star.svg';
import aHighRes from '../../static/imageAhighres.jpg';
import bHighRes from '../../static/imageBhighres.jpg';
const PageHemea = () => {
  const [isAccepted, setIsAccepted] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const history = useHistory();

  // we don't want the user to go directly to this page. In case of change, data from users & projects must be load first.
  if (history.action === 'POP') {
    history.push('/');
    return null;
  }
  const isHemeaSubmitted = useSelector(isHemeaSubmittedSelector);
  const selectedProject = useSelector(selectedProjectSelector);
  const {
    profile
  } = useSelector(userSelector);
  const {
    workTypesIds
  } = selectedProject || {};
  const {
    workTypes
  } = useSelector(projectSelector);
  const projectWorkTypes = Object.values(workTypes).filter(wt => workTypesIds.includes(wt.id)).map(w => w = w.tunnelCode);
  const {
    lastName,
    firstName,
    phoneNumber
  } = profile;
  const {
    address
  } = selectedProject;
  const {
    dealId
  } = selectedProject.dealAssociation;
  const sendInfo = () => {
    const dataForHemea = {
      dealId,
      projectWorkTypes,
      address,
      firstName,
      lastName,
      phoneNumber,
      isAccepted
    };
    axios.post(window.processRuntime.env?.MAKE_HEMEA_SCENARIO, dataForHemea).then(response => {
      setIsSubmitted(true);
    }, error => {
      console.log(error);
    });
  };
  return /*#__PURE__*/React.createElement(ProjectListWrapper, null, /*#__PURE__*/React.createElement(PageHemeaContainer, null, /*#__PURE__*/React.createElement(MainTitle, null, "Artisans"), /*#__PURE__*/React.createElement(PartnerContent, null, /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(MainLogo, {
    src: "https://images.hemea.com/static/logo-hemea-black-v2.png",
    alt: "Hemea Logo"
  }), /*#__PURE__*/React.createElement(Title, null, "Pr\xE9sentation de notre partenaire Hemea"), /*#__PURE__*/React.createElement(Text, null, "Hemea est un cabinet d'architecture et de r\xE9novation qui accompagne les particuliers sur leurs projets de r\xE9novation, extension, sur\xE9l\xE9vation et construction."), /*#__PURE__*/React.createElement(Text, null, "Op\xE9rant sur la France enti\xE8re en proposant un accompagnement de A \xE0 Z depuis la phase de conception jusqu'\xE0 la livraison du chantier, nous avons choisi pour la qualit\xE9 de son r\xE9seau d'entrepreneurs, soigneusement s\xE9lectionn\xE9s. Hemea apporte un accompagnement du d\xE9but \xE0 la fin du projet en s\xE9curisant les flux financiers et en apportant des garanties exclusives."), /*#__PURE__*/React.createElement(ItemsList, null, /*#__PURE__*/React.createElement(Item, null, /*#__PURE__*/React.createElement(Icon, {
    src: YellowStar,
    alt: "star-logo"
  }), "Respect du planning et des budgets"), /*#__PURE__*/React.createElement(Item, null, /*#__PURE__*/React.createElement(Icon, {
    src: YellowStar,
    alt: "star-logo"
  }), "Accompagnement sur-mesure"), /*#__PURE__*/React.createElement(Item, null, /*#__PURE__*/React.createElement(Icon, {
    src: YellowStar,
    alt: "star-logo"
  }), "\xC9quipe d\u2019experts"), /*#__PURE__*/React.createElement(Item, null, /*#__PURE__*/React.createElement(Icon, {
    src: YellowStar,
    alt: "star-logo"
  }), "S\xE9lection de garanties exclusives (p\xE9nalit\xE9s de retard, compte s\xE9questre, etc)")), /*#__PURE__*/React.createElement(Text, null, "Nous savons \xE0 quel point il est difficile de trouver des artisans de qualit\xE9 et surtout de confiance."), /*#__PURE__*/React.createElement(Text, null, "Pour vous simplifier la vie, nous avons \xE9tabli un partenariat exclusif avec Hemea qui vous offrira une prise en charge et un service optimal."), /*#__PURE__*/React.createElement(Title, null, "Comment \xEAtre mis en relation avec Hemea ?"), /*#__PURE__*/React.createElement(Text, {
    noMargin: true
  }, "En un clic, vos coordonn\xE9es et informations de votre projet seront transmis \xE0 Hemea de mani\xE8re s\xE9curis\xE9e. Une personne de chez Hemea pourra alors vous contacter pour vous \xE9tablir un devis avec ses artisans de qualit\xE9."), /*#__PURE__*/React.createElement(Text, {
    bold: true
  }, "Cette mise en relation est gratuite"), /*#__PURE__*/React.createElement(AdviseBlock, null, /*#__PURE__*/React.createElement(Advise, null, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    onChange: e => setIsAccepted(e.target.checked),
    checked: isHemeaSubmitted ? true : isAccepted
  }), "En cochant cette case, j\u2019accepte que mes coordon\xE9es et les informations de mon projet soient transmises \xE0 la soci\xE9t\xE9 Hemea et uniquement \xE0 la soci\xE9t\xE9 Hemea de mani\xE8re s\xE9curis\xE9e. J\u2019accepte \xE9galement que la soci\xE9t\xE9 Hemea prenne contact avec moi par t\xE9l\xE9phone et / ou par e-mail.")), /*#__PURE__*/React.createElement(ConfirmButton, {
    disabled: !isAccepted || isHemeaSubmitted || isSubmitted,
    onClick: () => sendInfo()
  }, isSubmitted || isHemeaSubmitted ? 'Demande envoyée' : 'Envoyer ma demande')), /*#__PURE__*/React.createElement(SideImage, null, /*#__PURE__*/React.createElement(Photo, {
    src: aHighRes,
    alt: ""
  }), /*#__PURE__*/React.createElement(Photo, {
    src: bHighRes,
    alt: ""
  })))));
};
export default PageHemea;